module.exports = "data:text/x-markdown;base64,Q29uZ3JhdHMhCgoKCkxvb2tpbmcgZm9yd2FyZCB0byBtZWV0aW5nIHlvdSBhdCBDcm9zc2xpbmsgMjAxOSE="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/MorganStark_complete.md
// module id = 1352
// module chunks = 0